<template>
  <el-dialog title="添加任务" :visible.sync="isShow" width="80%" center @close="$emit('close')" :show-close="false"
             :close-on-click-modal="false">
    <div class="add-video-warp-box">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <div class="flex-item">
          <el-form-item label="上传类型:" prop="newsType">
            <el-select v-model="form.newsType" size="small" placeholder="请选择上传类型" clearable>
              <el-option value="SP" label="短视频"></el-option>
              <el-option value="MOVIE" label="影视"></el-option>
              <el-option value="COVER" label="图集"></el-option>
              <el-option value="AD_SP" label="视频广告"></el-option>
              <el-option value="AD_COVER" label="图片广告"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="flex-item">
          <el-form-item label="上传视频:"
                        v-if="form.newsType === 'SP' || form.newsType === 'AD_SP' || form.newsType === 'MOVIE'">
            <input type="file" @change="changeFile" accept="video/*" id="inputFile">
          </el-form-item>
          <el-form-item label="封面上传:" prop="cover" v-if="
              (form.newsType === 'SP' || form.newsType === 'AD_SP') || form.newsType === 'MOVIE'  ">
            <base-upload :cover="form.cover" :action="action" @successCallback="successCallback" :id="form.sourceID"
                         :wSize="360" :hSize="640" :width="'120px'" :height="'213px'"></base-upload>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item style="width: 1100px" label="上传图集:" prop="cover" v-if="
              form.newsType === 'COVER' ||
              form.newsType === 'AD_COVER' ||
              form.newsType === 'AD_SP'
            ">
            <!--上传图集-->
            <imgs-upload :cover="form.cover" :action="actionPics" @successCallback="successCallbackPic"
                         :id="form.sourceID" :wSize="180" :hSize="320" :width="'100px'" :height="'100px'" ref="imgsUpload"></imgs-upload>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="视频标题:" prop="title">
            <el-input v-model="form.title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="免费时长:" prop="freeTime">
            <el-input v-model.number="form.freeTime" size="small"></el-input>
          </el-form-item>
          <el-form-item label="帖子定价:" prop="coins" v-if="form.newsType === 'SP' || form.newsType === 'COVER'">
            <el-input v-model.number="form.coins" size="small" @input="changeInput()"></el-input>
          </el-form-item>
          <el-form-item v-else></el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="城市填写:" prop="location.city">
            <el-input v-model="form.location.city" size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户ID:" prop="uid" flex="1">
            <el-input v-model.number="form.uid" size="small" placeholder="请输入用户ID"></el-input>
          </el-form-item>
          <el-form-item label="广告排序号:" prop="sortCode">
            <el-input v-model.number="form.sortCode" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="flex-item" v-if="form.newsType === 'SP' || form.newsType === 'AD_SP'">
          <el-form-item label="视频来源:" prop="via">
            <el-input v-model="form.via" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="广告跳转连接:" prop="linkUrl">
            <el-input type="textarea" v-model="form.linkUrl" size="small"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <el-form-item label="标签:">
          <el-input type="textarea" :rows="3" placeholder="内容以“，”号隔开，如“张三，李四”" v-model="tagString"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitDate">立即添加</el-button>
          <el-button size="small" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import {validatorIndex} from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  props: ["isShow"],
  data() {
    return {
      SeriesCover: [],
      trackId: "",
      show: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      // 视频播放地址
      videoBaseUrl: baseConfig.playVideoUrl,
      tagString: "",
      isFree: true,
      flag: false,
      player: "",
      files: null,
      // 表单数据
      form: {
        uid: "",
        title: "",
        newsType: "SP", //上传文件类型
        tags: [],
        playTime: "",
        cover: "",
        coverThumb: "",
        via: "admin",
        isFree: 0,
        coins: 0,
        size: "",
        mimeType: "",
        sourceURL: "",
        sourceID: "",
        filename: "",
        resolution: "",
        md5: "",
        freeTime: 3,
        location: {
          city: "",
        },
        SeriesCover: [],
      },
      rules: {
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        via: [{message: "请输入视频来源", trigger: "blur"}],
        coins: [
          {required: true, message: "请输入视频定价", trigger: "blur"},
          {validator: validatorIndex, trigger: "blur"},
        ],
        location: {
          city: [
            {required: true, message: "请输入城市名称", trigger: "blur"},
          ],
        },
        uid: [
          {required: true, message: "请输入用户uid", trigger: "blur"},
          {validator: validatorIndex, trigger: "blur"},
        ],
      },
    };
  },
  methods: {
    changeFile(event) {
      let files = event.target.files[0];
      let title = files.name.split('.')[0]
      if (title) {
        this.form.title = title
      }
      this.files = files;
    },
    cancel() {
      this.cleanForm();
      this.$emit("close");
    },
    // 提交验证
    submitDate() {
      if (!this.tagString) {
        this.$message.error("标签不能为空！");
        return false;
      }
      if (
          (this.form.newsType === "SP" ||
              this.form.newsType === "AD_SP" ||
              this.form.newsType === "MOVIE") &&
          !this.files
      ) {
        this.$message.error("请选择视频");
        return false;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.tags = this.tagString.split("，");
          let data = {
            files: this.files || null,
            form: this.form,
            time: new Date().getTime(),
          };
          this.$emit("addTaskSuccess", data);
          this.$emit("close");
          this.cleanForm();
        } else {
          return false;
        }
      });
    },
    cleanForm() {
      this.files = null;
      this.tagString = "";
      let dom = document.querySelector("#inputFile");
      if (dom) {
        dom.value = "";
      }
      console.log(this.$refs.imgsUpload)
      this.$refs.imgsUpload && this.$refs.imgsUpload.clearImg();
      //保存上一次
      let newsType = this.form.newsType;
      let freeTime = this.form.freeTime;
      let location = this.form.location;
      let uid = this.form.uid;

      this.form = {
        uid: "",
        title: "",
        newsType: "SP", //上传文件类型
        tags: [],
        playTime: "",
        cover: "",
        coverThumb: "",
        via: "admin",
        isFree: 0,
        coins: 0,
        size: "",
        mimeType: "",
        sourceURL: "",
        sourceID: "",
        filename: "",
        resolution: "",
        md5: "",
        freeTime: 3,
        location: {
          city: "",
        },
        SeriesCover: [],
      };
      this.form.newsType = newsType;
      this.form.freeTime = freeTime;
      this.form.location = location;
      this.form.uid = uid;
    },
    // 监听视频定价价格动态改变是否是免费视频状态
    changeInput() {
      if (this.form.coins > 0) {
        this.isFree = true;
        this.form.isFree = 1;
      } else {
        this.isFree = false;
        this.form.isFree = 0;
      }
    },
    // 封面图上传成功回调
    successCallback(res) {
      this.form.cover = res.data.coverImg;
      this.form.coverThumb = res.data.coverImg;
    },
    // 封面图上传成功回调
    successCallbackPic(seriesCover) {
      this.form.seriesCover = seriesCover;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-video-warp-box {
  .flex-item {
    width: 90%;
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }

  .el-upload .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }

  .el-textarea {
    width: 500px;
  }

  .el-input {
    width: 250px;
  }

  .uploader-drop {
    background: none;
    border-radius: 5px;
    border: none;
    padding: 0;
  }

  .uploader-file {
    border-bottom: 1px dashed #ccc;
  }

  .uploader-btn {
    background: #e63765;
    color: white;
    padding: 5px 10px;
    font-size: 13px;
    border: none;
    border-radius: 3px;

    &:hover {
      background: #eb5f84;
    }
  }

  .title {
    width: 100%;
    height: 30px;
    display: inline-block;
    font-size: 14px;
    line-height: 30px;
    overflow: hidden;
    color: #666;
    margin-bottom: 15px;
    cursor: pointer;

    i {
      &:hover {
        color: #e63765;
      }
    }

    span {
      margin-left: 10px;
    }
  }

  .upload-video {
    width: 300px !important;

    .circle-bar {
      width: 100%;
      height: 100%;
      text-align: center;

      .el-progress-circle {
        margin: 0 auto;
        margin-top: 8px;
      }
    }

    .video-box {
      width: 100%;
      height: 100%;
    }
  }

  .avatar-uploader {
    width: 150px;
    height: 150px;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border: 1px dashed #e63765;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}

.show {
  left: 20px;
  transition: left 0.2s linear;
}
</style>
